module.exports = __webpack_public_path__ + "img/collection-engagementRingsFancy@2x.f8a432c.webp";